import Loader from "components/Loader";
import React, { useEffect, useReducer, useState, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import SurveyService from "services/SurveyService";
import { surveyState } from "store/reducers/surveyReducer";
import { surveyReducer } from "store/reducers/surveyReducer";
import SurveyCard from "../SurveyCard/SurveyCard";
import CreateNewSurvey from "./CreateNewSurvey";
import ManageSurveyModal from "./ManageSurveyModal";
import FilterSurvey from "../FilterSurvey/FilterSurvey";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "components/CustomButton";
import Button from "components/CustomButton";

export default () => {
  const params = useParams();
  const location = useLocation();
  const [
    {
      loadingList,
      teamSurveys,
      createNewSurvey,
      reload,
      activeSurvey,
      addQuestions,
      isCreating,
      teamQuestions,
      prePopulatedQuestions,
      selectedQuestions,
      isSubmittingAns,
      surveyPage,
      surveyTotal,
    },
    dispatch,
  ] = useReducer(surveyReducer, surveyState);

  const [order_by, setOrderBy] = useState("newest");
  const [status_id, setStatusId] = useState(null);
  const isInitialMount = useRef(true);

  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  const fetchSurveys = async (page = 1, reset = false) => {
    try {
      if (reset) {
        dispatch({
          type: "loadingList",
          value: true,
        });
        dispatch({
          type: "clearSurveys",
        });
      }

      const resp = await SurveyService.getSurveyListWithPagination(
        params.teamId,
        page,
        10,
        status_id,
        order_by
      );

      if (resp.data && resp.data.data) {
        if (reset || page === 1) {
          dispatch({
            type: "setTeamSurveys",
            value: resp.data.data,
          });
        } else {
          dispatch({
            type: "appendTeamSurveys",
            value: resp.data.data,
          });
        }

        if (resp.data.meta) {
          dispatch({
            type: "setSurveyTotal",
            value: resp.data.meta.total || 0,
          });
          dispatch({
            type: "setSurveyMeta",
            value: resp.data.meta,
          });
        }

        if (resp.data.meta && resp.data.meta.current_page) {
          dispatch({
            type: "setSurveyPage",
            value: resp.data.meta.current_page,
          });
        }
      }

      dispatch({
        type: "loadingList",
        value: false,
      });
    } catch (e) {
      dispatch({
        type: "loadingList",
        value: false,
      });
      if (reset || page === 1) {
        dispatch({
          type: "setTeamSurveys",
          value: [],
        });
      }
    }
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      fetchSurveys(1, true);
      return;
    }
    
    fetchSurveys(1, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.teamId, order_by, status_id]);

  useEffect(() => {
    if (reload) {
      fetchSurveys(1, true);
      dispatch({
        type: "setReload",
        value: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const surveyIdParam = searchParams.get('surveyId');
    
    if (surveyIdParam && teamSurveys.length > 0) {
      const surveyId = parseInt(surveyIdParam);
      const survey = teamSurveys.find((s) => s.id === surveyId);
      
      if (survey && activeSurvey !== surveyId) {
        setActiveSurvey(surveyId);
        // Remove the query parameter from URL
        const newSearch = new URLSearchParams(location.search);
        newSearch.delete('surveyId');
        window.history.replaceState({}, '', `${location.pathname}${newSearch.toString() ? `?${newSearch.toString()}` : ''}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, teamSurveys]);

  const handleCreateNewSurvey = () =>
    dispatch({
      type: "handleCreateNewSurvey",
      value: !createNewSurvey,
    });

  const setActiveSurvey = (id) => {
    dispatch({
      type: "manageActiveSurvey",
      value: id,
    });
  };

  const getNextPageData = () => {
    const nextPage = surveyPage + 1;
    fetchSurveys(nextPage, false);
  };

  const setSurveys = () => {
    dispatch({
      type: "clearSurveys",
    });
  };

  const setPage = () => {
    dispatch({
      type: "clearSurveys",
    });
    dispatch({
      type: "setSurveyPage",
      value: 1,
    });
  };

  const noSurveys = {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    padding: "100px 0",
    fontSize: "22px",
    fontWeight: "500",
  };

  const LoadingContainer = (
    <>
      {loadingList && (
        <h4>
          <Loader loaderStyle={LoaderStyle} />
        </h4>
      )}
      {!loadingList && (
        <h4>
          <Button onClick={getNextPageData}>Load More</Button>
        </h4>
      )}
    </>
  );

  return (
    <div className="py-4">
      <div className="tasks-btn mb-3">
        <div className="task-left-btn">
          <CustomButton
            onClick={handleCreateNewSurvey}
            buttonClass="light-gray-btn d-inline-block mb-3"
          >
            <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
            Add Survey
          </CustomButton>
        </div>
        <FilterSurvey
          setStatusId={setStatusId}
          setPage={setPage}
          setIsLoading={(value) =>
            dispatch({
              type: "loadingList",
              value: value,
            })
          }
          setSurveys={setSurveys}
          setOrderBy={setOrderBy}
          order_by={order_by}
          status_id={status_id}
        />
      </div>

      {loadingList && surveyPage === 1 && teamSurveys.length === 0 && (
        <div style={{ display: "flex", justifyContent: "center", padding: "100px 0" }}>
          <Loader />
        </div>
      )}

      {!loadingList && surveyPage === 1 && teamSurveys.length === 0 && (
        <div style={noSurveys}>
          No surveys created yet, create your first survey
        </div>
      )}

      <InfiniteScroll
        style={{ overflow: "hidden" }}
        dataLength={teamSurveys.length}
        next={getNextPageData}
        hasMore={teamSurveys.length < surveyTotal}
        loader={LoadingContainer}
        scrollableTarget="main-panel-right"
        endMessage={
          <div style={{ textAlign: "center" }}>
            {surveyTotal > 0 && <div>Yay! You have seen it all</div>}
          </div>
        }
      >
        {teamSurveys.length > 0 && (
          <div className="surveys-cards">
            <div className="row surveyRow">
              {teamSurveys.map((survey, index) => (
                <SurveyCard
                  key={survey.id || index}
                  survey={survey}
                  dispatch={dispatch}
                  reload={reload}
                  teamSurveys={teamSurveys}
                  activeSurvey={activeSurvey}
                  setActiveSurvey={setActiveSurvey}
                />
              ))}
            </div>
          </div>
        )}
      </InfiniteScroll>

      {activeSurvey > 0 && teamSurveys.find((s) => s.id === activeSurvey) && (
        <ManageSurveyModal
          survey={teamSurveys.find((s) => s.id === activeSurvey)}
          onClose={() => setActiveSurvey(0)}
          activeSurvey={activeSurvey}
          addQuestions={addQuestions}
          dispatch={dispatch}
          teamQuestions={teamQuestions}
          prePopulatedQuestions={prePopulatedQuestions}
          selectedQuestions={selectedQuestions}
          isSubmittingAns={isSubmittingAns}
          reload={reload}
          teamSurveys={teamSurveys}
        />
      )}

      {createNewSurvey && (
        <CreateNewSurvey
          dispatch={dispatch}
          onClose={handleCreateNewSurvey}
          teamSurveys={teamSurveys}
          reload={reload}
          isCreating={isCreating}
        />
      )}
    </div>
  );
};
